/**
 * Template Center catalog IA — department-first (not methodology-first).
 *
 * Primary browse answers "which team / job?" Modern platforms (Asana, monday,
 * Jira Work Management, Wrike, Airtable) use department/function rails.
 * Methodology stays a template engine attribute for instantiate/Blueprint —
 * never a top-level TIERS group.
 *
 * `PROJECT_TEMPLATE_CATEGORIES` remains the save-as-template / seed category
 * union (Phase 5A). Browse grouping uses `DEPARTMENT_CATALOG_CATEGORIES`.
 */

export const PROJECT_TEMPLATE_CATEGORIES = [
  'Project Management',
  'Product Management',
  'Software Development',
  'Operations',
  'Startups',
] as const;

export type ProjectTemplateCategory =
  (typeof PROJECT_TEMPLATE_CATEGORIES)[number];

export function isProjectTemplateCategory(
  v: unknown,
): v is ProjectTemplateCategory {
  return (
    typeof v === 'string' &&
    (PROJECT_TEMPLATE_CATEGORIES as readonly string[]).includes(v)
  );
}

/**
 * Locked left-rail order for Template Center browse.
 * Empty buckets are omitted at render time; order is preserved for non-empty.
 */
export const DEPARTMENT_CATALOG_CATEGORIES = [
  'Starters',
  'Marketing',
  'Product & Engineering',
  'Operations & PMO',
  'IT & Service',
  'HR & People',
  'Sales & CX',
  'Your templates',
] as const;

export type DepartmentCatalogCategory =
  (typeof DEPARTMENT_CATALOG_CATEGORIES)[number];

/** @deprecated Alias — use DEPARTMENT_CATALOG_CATEGORIES. */
export const CATALOG_TIER_CATEGORIES = DEPARTMENT_CATALOG_CATEGORIES;

/** @deprecated Alias — use DepartmentCatalogCategory. */
export type CatalogTierCategory = DepartmentCatalogCategory;
